import { AppNS } from 'app';
import { signInWithToken } from 'app/services/jwtService';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';

export const useAuthQuery = (queryOptions: UseQueryOptions<AppNS.User, string[], AppNS.User> = {}) => {
  return useQuery({
    queryKey: ['auth'],
    queryFn: () => signInWithToken(),
    refetchOnWindowFocus: 'always',
    ...queryOptions,
  });
};
